// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3kaha","options":"AnswerScale_options__3zdd6","selected":"AnswerScale_selected__3Bvj5"};